const WarningTextEnum = {
  INVALID_JSON: 'Invalid JSON Object!',
  INVALID_DATA: 'Some wrong message is being sent by Parent.',
  URL_REQUIRED: 'Url is needed for creating and opening a new window/tab.'
};

module.exports = WarningTextEnum;




/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/enums/WarningTextEnum.js
 **/